import React from 'react';
import { TEXT_TYPES } from '../../../utils/Constants';
import * as globalStyles from '../../../utils/GlobalStyles';
import LabelView from '../../atoms/LabelView';
import LoadingSpinnerView from '../../atoms/LoadingSpinnerView';

export default function MaskView(props) {
  const { isLoading, message, hideVeilColor = false, isFaded, customVeilColor, spinnerPaddingTopPx = 0 } = props;

  const veilColor = hideVeilColor ? null : customVeilColor || globalStyles.colors.transparentBase3;

  const dynamicStyle = {
    ...style,
    backgroundColor: veilColor,
    justifyContent: spinnerPaddingTopPx != 0 ? undefined : 'center'
  };
  
  const dynamicSpinnerStyle = {
    opacity: isFaded ? 0.5 : undefined,
    paddingTop: spinnerPaddingTopPx,
  };

  return (
    <div style={{ position: 'relative' }}>
      {props.children}
      {isLoading && (
        <div style={dynamicStyle}>
          <LoadingSpinnerView isLoading={isLoading} style={dynamicSpinnerStyle} />
          {message && <LabelView text={message} type={TEXT_TYPES.ITEM_HEADER} style={labelStyle} />}
        </div>
      )}
    </div>
  );
}

const style = {
  top: 0,
  width: '100%',
  height: '100%',
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const labelStyle = {
  marginTop: 16,
};
